import { render, staticRenderFns } from "./RadioButtonDemo.vue?vue&type=template&id=18c22818&scoped=true&"
import script from "./RadioButtonDemo.vue?vue&type=script&lang=js&"
export * from "./RadioButtonDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c22818",
  null
  
)

export default component.exports